export const DEFAULT_FHIR_BASE_API_URL = "https://demo.kodjin.com/fhir";
